import { useCallback, useEffect, useState } from 'react';

export type CustomerOrgTabValue = 'overview' | 'plan' | 'sso' | 'users' | 'admins' | 'danger';

export const CUSTOMER_ORG_TABS: { value: CustomerOrgTabValue; label: string }[] = [
  { value: 'overview', label: 'Overview' },
  { value: 'plan', label: 'Plan & Limits' },
  { value: 'sso', label: 'SSO / IDP' },
  { value: 'users', label: 'Users' },
  { value: 'admins', label: 'Admins' },
  { value: 'danger', label: 'Danger zone' },
];

export function useCustomerOrgDrawerTabs(orgId: number | null) {
  const [activeTab, setActiveTab] = useState<CustomerOrgTabValue>('overview');

  useEffect(() => {
    setActiveTab('overview');
  }, [orgId]);

  const handleTabChange = useCallback(
    (_: React.SyntheticEvent, newValue: CustomerOrgTabValue) => setActiveTab(newValue),
    [],
  );

  return { activeTab, handleTabChange, tabs: CUSTOMER_ORG_TABS };
}
